import { useRouter } from 'next/router';

import { Icon } from 'common/icon';
import { SlotActionBlockParams } from 'constants/templates';

import styles from './styles.module.css';
import clsx from 'clsx';

const IconVariant = {
  save: 'save',
  inspect: 'inspect',
  search: 'search',
  remove: 'remove',
};

export const ActionBlockButton = ({
  data,
  isSlot,
  className,
}: {
  isSlot?: boolean;
  data: SlotActionBlockParams[];
  className?: string;
}) => {
  const router = useRouter();

  const renderIcon = (icon: string) => {
    switch (icon) {
      case IconVariant.save:
        return <Icon.Save />;
      case IconVariant.inspect:
        return <Icon.Inspect />;
      case IconVariant.search:
        return <Icon.Search />;
      case IconVariant.remove:
        return <Icon.Remove />;
      default:
        return null;
    }
  };

  return (
    <div
      className={clsx(
        isSlot ? styles.slot_block__actions : styles.casino_block__actions,
        className
      )}
    >
      {data?.map(({ onClick, text, icon, anchorId, id }, index) => (
        <div
          id={(id ?? '')?.toString()}
          onClick={() => {
            if (anchorId) {
              router.replace(`#${anchorId}`);
            }

            if (onClick) {
              onClick();
              return;
            }
          }}
          key={anchorId?.toString() + index?.toString()}
          className={clsx({
            [styles.slot_block__action]: true,
            [styles.no_hover]: anchorId === null,
          })}
        >
          {renderIcon(icon)}
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
};
